import React from 'react';
import { Modal } from '../';
import { Typography } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

export const DeleteModal = ({
    open,
    onCancel,
    onConfirm,
    title = 'Confirm Delete',
    message = 'Are you sure you want to delete this item?',
    warningMessage = 'Once deleted, it cannot be recovered.',
    items = [], // For bulk delete - show list of items
    confirmLoading = false,
    okText = 'Delete',
    cancelText = 'Cancel',
    ...modalProps
}) => {
    return (
        <Modal
            title={
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <ExclamationCircleOutlined style={{ color: 'var(--color-error)', marginRight: 8 }} />
                    {title}
                </div>
            }
            open={open}
            onCancel={onCancel}
            onOk={onConfirm}
            okText={okText}
            cancelText={cancelText}
            okButtonProps={{ danger: true }}
            confirmLoading={confirmLoading}
            width={500}
            {...modalProps}
        >
            <div style={{ marginTop: 16 }}>
                <Text>{message}</Text>

                {warningMessage && (
                    <div style={{ marginTop: 12 }}>
                        <Text style={{ color: 'var(--color-error)', fontWeight: 'var(--body-bold-font-weight)' }}>
                            {warningMessage}
                        </Text>
                    </div>
                )}

                {items.length > 0 && (
                    <div style={{ marginTop: 16 }}>
                        <Text strong>Items to be deleted:</Text>
                        <ul style={{ marginTop: 8, paddingLeft: 20 }}>
                            {items.map((item, index) => (
                                <li key={index}>
                                    <Text>{item.name || item}</Text>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        </Modal>
    );
};
